<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section>
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column [xs]="12">
          <div class="registration-confirmation-page-title mb-5">
            <h1 class="mb-5">
              {{ vm.cmsData.registrationConfirmationPageTitle }}
            </h1>
            <p class="mb-5">
              {{ vm.cmsData.registrationConfirmationPageSubtitle }}
            </p>
          </div>
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>

    <dgx-components-grid-container *sharedSectionLoading="!vm.registrationCPG">
      <dgx-components-grid-row
        *ngIf="vm.registrationCPG && vm.showRegistrationCPG"
      >
        <dgx-components-grid-column
          [md]="6"
          [mdOrder]="1"
          [xs]="12"
          [xsOrder]="2"
        >
          <us-registration-confirmation-appliance-details-panel
            *ngFor="let registeredAppliance of vm.registeredAppliances"
            [registeredAppliance]="registeredAppliance"
            [registriaUserResponse]="vm.registriaUserResponse"
            [stacked]="vm.isMobile"
            class="d-block pb-3"
            variant="background-alternative"
          />
        </dgx-components-grid-column>

        <dgx-components-grid-column
          [md]="6"
          [mdOrder]="2"
          [xs]="12"
          [xsOrder]="1"
        >
          <us-registration-confirmation-cpg-panel
            *ngIf="vm.registrationCPG && vm.showRegistrationCPG"
            [applianceCPG]="vm.registrationCPG"
            class="d-block pb-3"
            variant="background-alternative"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>

      <dgx-components-grid-row *ngIf="!vm.showRegistrationCPG">
        <dgx-components-grid-column [md]="6" [xs]="12">
          <us-registration-confirmation-appliance-details-panel
            *ngFor="let registeredAppliance of vm.registeredAppliances"
            [registeredAppliance]="registeredAppliance"
            [registriaUserResponse]="vm.registriaUserResponse"
            [stacked]="vm.isMobile"
            class="d-block pb-3"
            variant="background-alternative"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</ng-container>
